<template>
<div class="bg padding">


  <el-select v-model="findType" placeholder="请选择">
     <el-option key="Month" label="月度统计" value="Month"> </el-option>
     <el-option key="Quarter" label="季度统计" value="Quarter"> </el-option>
    <el-option key="Day" label="日统计" value="Day"> </el-option>
  </el-select>

    <el-date-picker v-if="findType=='Month' || findType=='Quarter'"
      v-model="year"
      type="year"
      value-format="yyyy"
      placeholder="选择年">
    </el-date-picker>

     <el-date-picker
      v-if="findType=='Day'"
      v-model="month"
      type="month"
      value-format="yyyy-MM"
      placeholder="选择月">
    </el-date-picker>

  <el-button type="primary" @click="find">查询</el-button>
  
    <div class="center padding title"  v-if="findType=='Month'"><h1>{{libraryInfo.name}} {{year}}年度报表</h1></div>
    <div class="center padding title" v-if="findType=='Quarter'"><h1>{{libraryInfo.name}} {{year}}季度报表</h1></div>
    <div class="center padding title" v-if="findType=='Day'"><h1>{{libraryInfo.name}} {{month}}月报表</h1></div>

    <el-table class="center"
        :data="inOutlist"
        stripe
        
        style="width: 60%">

        <el-table-column
            prop="Name"
            align="center"
            label="日期">
        </el-table-column>
        <el-table-column
            prop="DataIn"
             align="center"
            label="进馆人数">
        </el-table-column>
        <el-table-column
            prop="DataOut"
             align="center"
            label="出馆人数">
        </el-table-column>
    </el-table>

</div>
</template>

<script>
import { getAjsHeaderInfo } from "@/api/open";
import {getLibrary, getQuestionnaireQrCodeById} from "@/api/study";
import {
  getDayEntityHourData,
  getDayEntityData,
  getEntityWeekData,
  getEntityMonthData,
  getLowEntityMonthData,
  getEntityQuarterData,
  getEntityYearData,
  getEntityAllYearData} from '@/api/anjisheng';
  
  export default {
    data() {
      return {
        findType:'Month',
        year:null,
        month:null,
        libraryId:null,
        libraryInfo:{},
        headerInfo:{}, 
        inOutlist: [],
        BeginTime:null,
        EndTime:null
      }
    },
    created() {
        if (this.$route.query.libraryId) {
          this.libraryId = this.$route.query.libraryId;
        }
       
        this.year = this.formatDate(new Date(),"yyyy");
        this.month = this.formatDate(new Date(),"yyyy-MM");
        this.getOpenData()
    },
    methods:{
        find(){
         
            if(this.findType=='Month'){
                this.BeginTime = this.year+"-01-01 "+"00:00:00"
                this.EndTime = this.year+"-12-31 "+"23:59:59"
                this.getEntityMonthData(this.BeginTime,this.EndTime);
            }else if(this.findType=='Quarter'){
                this.BeginTime = this.year+"-01-01 "+"00:00:00"
                this.EndTime = this.year+"-12-31 "+"23:59:59"
                this.getEntityQuarterData(this.BeginTime,this.EndTime);
            }else if(this.findType=='Day'){
                this.BeginTime = this.month+"-01 "+"00:00:00"
                this.EndTime = this.month+"-"+this.getMonthEndDay(this.month.split('-')[1])+" 23:59:59"
                this.getDayEntityData(this.BeginTime,this.EndTime);
            }
        },
          getOpenData() {
                var _this= this;
                getAjsHeaderInfo().then(response => {
                this.headerInfo = response.data;
                  sessionStorage.setItem('headerInfo',JSON.stringify(this.headerInfo));
                _this.getLibraryInfo();
                });
          },
          getLibraryInfo(){
                getLibrary(this.libraryId).then(response=>{
                    this.libraryInfo = response.data;
                    sessionStorage.setItem('libraryInfo',JSON.stringify(this.libraryInfo));
                  
                  
                })
          },
          getDayEntityData(BeginTime,EndTime){
                    var _this = this
                    var libraryInfo = this.libraryInfo;
                     getDayEntityData(libraryInfo.entityId,BeginTime,EndTime).then(response => {
                            var inOutlist = response.Data;
                            _this.inOutlist = inOutlist;
                        })
          }, 
           getEntityMonthData(BeginTime,EndTime){
   
                   var _this = this
                    var libraryInfo = this.libraryInfo;
                    getEntityMonthData(libraryInfo.entityId,BeginTime,EndTime).then(response => {
                              var inOutlist = response.Data;
                            _this.inOutlist = inOutlist;
                        })
            },

            getEntityQuarterData(BeginTime,EndTime){
                var _this = this
                    var libraryInfo = this.libraryInfo;
                getEntityQuarterData(libraryInfo.entityId,BeginTime,EndTime).then(response => {
                            var inOutlist = response.Data;
                            _this.inOutlist = inOutlist;
                        })
            },
                
            getEntityYearData(){
                var _this = this
                var libraryInfo = this.libraryInfo;
                 getEntityYearData(libraryInfo.entityId).then(response => {
                              var inOutlist = response.Data;
                            _this.inOutlist = inOutlist;
                        })
            },
            // date.js
            formatDate(date, fmt) {
                    if (/(y+)/.test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                    }
                    let o = {
                        'M+': date.getMonth() + 1,
                        'd+': date.getDate(),
                        'h+': date.getHours(),
                        'm+': date.getMinutes(),
                        's+': date.getSeconds()
                    };
                    for (let k in o) {
                        if (new RegExp(`(${k})`).test(fmt)) {
                        let str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
                        }
                    }
                    return fmt;
            },
            getMonthEndDay(beginmonth){
                var year =   this.formatDate(new Date(),"yyyy");
                var month ;
                if(beginmonth){
                    month = beginmonth;
                }else{
                    month =    this.formatDate(new Date(),"MM");
                }
                var day31=['1','3','5','7','8','10','12','01','03','05','07','08']
                var day30=['4','6','9','11','04','06','09']
                if(month==2){
                    if( year%4==0&&year%100!=0){
                        return 29;
                    }else{
                        return 27;
                    }
                }
                if(day31.indexOf(month)!=-1){
                    return 31;
                }else if(day30.indexOf(month)!=-1){
                    return 30;
                }else{
                    return 30;
                }

            },padLeftZero(str) {
                    return ('00' + str).substr(str.length);
             }
    }
  }
</script>
<style scoped>
   
   .center{
    text-align: center;
    margin: 0px auto;
   }
   .bg{

   }
   .padding{
    padding: 40px 40px 40px 40px;
   }
   .title{
    font-size: 28px;
    color: aliceblue;
   }
</style>


// WEBPACK FOOTER //
// src/components/flowrateReport.vue